// Shared conversion tables for MBA admissions evaluation
// Used across all schools for standardized score conversions

export const GMAT_CONVERSION_TABLE = `
GMAT SCORE CONVERSIONS (Classic ↔ Focus):
Classic → Focus → Percentile
800 → 805 → 100%
790 → 785 → 100%
780 → 755 → 100%
770 → 735 → 99.9%
760 → 715 → 99.5%
750 → 695 → 98.7%
740 → 685 → 97.9%
730 → 675 → 96.7%
720 → 665 → 95.2%
710 → 655 → 93.2%
700 → 645 → 89.6%
690 → 635 → 86.7%
680 → 615 → 83.5%
670 → 615 → 80.1%
660 → 615 → 78.3%
650 → 595 → 74.5%
640 → 585 → 70.7%
630 → 585 → 64.8%
620 → 575 → 62.8%
610 → 565 → 58.9%
600 → 555 → 55.1%
590 → 555 → 51.4%
580 → 545 → 47.8%
570 → 535 → 44.3%
560 → 525 → 41.1%
550 → 515 → 37.9%
540 → 515 → 35%
530 → 495 → 32.3%
520 → 495 → 28.5%
510 → 495 → 27.3%
500 → 485 → 25.1%

EXAMPLES:
- GMAT Focus 715 = GMAT Classic 760
- GMAT Focus 675 = GMAT Classic 730  
- GMAT Focus 655 = GMAT Classic 710
- GMAT Focus 645 = GMAT Classic 700
`;

export const GRE_CONVERSION_TABLE = `
GRE TO GMAT CLASSIC CONVERSION:
GRE → GMAT Classic
340 → 800
338 → 780
336 → 760
334 → 740
332 → 720
330 → 700
328 → 680
326 → 660
324 → 640
322 → 620
320 → 600
318 → 580
316 → 560
314 → 540
312 → 520
310 → 500
308 → 480
306 → 460
304 → 440
302 → 420
300 → 400
298 → 380
296 → 360
294 → 340
292 → 320
290 → 300
288 → 280

EXAMPLES:
- GRE 330 = GMAT Classic 700
- GRE 332 = GMAT Classic 720
- GRE 334 = GMAT Classic 740
`;

export const GPA_CONVERSION_TABLE = `
GPA CONVERSION GUIDELINES:

IMPORTANT: Only convert GPA if it's clearly NOT on a 4.0 scale.

Conversion Rules:
1. If GPA < 4.0 with no denominator (e.g., "3.3") → Assume already on 4.0 scale, NO conversion
2. If GPA with /4 denominator (e.g., "3.3/4") → Already on 4.0 scale, NO conversion  
3. If GPA with other denominator (e.g., "8.6/10", "75/100") → Convert using appropriate formula
4. If GPA > 4.0 with no denominator → This is ambiguous, note in evaluation that scale needs clarification

NATURAL EVALUATION APPROACH:
- When GPA is already on 4.0 scale, simply state the GPA and compare to benchmarks without lengthy conversion explanations
- Focus on the academic performance relative to school standards, not conversion mechanics
- Example: "His GPA of 3.3 is below our benchmark of 3.7" (NOT "Since it's not on a 4.0 scale, we should note...")
- Sound conversational, like admissions officers naturally discussing a candidate

Conversion Formulas:
- 10-point scale: GPA = (CGPA ÷ 10) × 4
  Example: 8.6/10 → (8.6 ÷ 10) × 4 = 3.44 GPA
- 100-point scale: GPA = (Score ÷ 100) × 4  
  Example: 85/100 → (85 ÷ 100) × 4 = 3.40 GPA
- UK First Class (70%+) ≈ 3.7-4.0 GPA
- UK Upper Second (60-69%) ≈ 3.3-3.6 GPA  
- UK Lower Second (50-59%) ≈ 3.0-3.2 GPA

CRITICAL: Always show your conversion calculation when you do convert.
DO NOT convert GPAs that are already on 4.0 scale.
`; 